var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.232 1.84733C4.81075 1.6156 6.40433 1.49951 8 1.5C9.62 1.5 11.2113 1.61867 12.768 1.84667C14.0867 2.04133 15 3.196 15 4.49333V8.50667C15 9.804 14.0867 10.9587 12.768 11.1533C11.4747 11.3427 10.1573 11.4567 8.82 11.49C8.75352 11.4913 8.69005 11.518 8.64267 11.5647L5.85333 14.3533C5.78341 14.4232 5.69436 14.4707 5.59742 14.49C5.50049 14.5092 5.40003 14.4993 5.30872 14.4615C5.21741 14.4237 5.13935 14.3597 5.08441 14.2776C5.02946 14.1954 5.00009 14.0988 5 14V11.3633C4.40886 11.3092 3.8193 11.239 3.232 11.1527C1.91333 10.9593 1 9.80334 1 8.506V4.494C1 3.19667 1.91333 2.04067 3.232 1.84733Z",
    fill: "#CDCED6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.77c292f861c08c0687096a3349279bd8.svg";
export { ForwardRef as ReactComponent };